import React from "react";
import "./Why_nutricos.css";
import Heading_title from "../../common-components/common-title/heading-title/Heading_title";
import Common_Title_2 from "../../common-components/common_title_2/Common_Title_2";

const Why_nutricos = () => {
  const whyNutricosData = [
    {
      image: "/assets/images/home/why-nutricos/img3.jpg",
      title: "Small Bites. Big Smiles.",
      description: "Crunch, Fun & Childhood Happiness.",
    },
    {
      image: "/assets/images/home/why-nutricos/img4.jpg",

      title: "Made for Busy Days & Smart Snacking.",
      description:
        "Nutricos Mobile Khakhra — The perfect light and crispy snack for busy workdays, evening breaks, and anytime munching.",
    },
    {
      image: "/assets/images/home/why-nutricos/img5.jpeg",
      title: "Mass affordable",
      description: "Truly priced for everyone.",
    },
    {
      image: "/assets/images/home/why-nutricos/img1.jpg",
      title: "Made to Refresh Every Mood",
      description: "Designed for impulse and repeat",
    },
  ];

  return (
    <>
      <section className="Why_nutricos_sec">
        <div className="container">
          <Common_Title_2
            titleText="Why Nutricos"
            subText="Nutricos is not a premium experiment."
            simpleText="It’s a mass movement."
          />
          {/* 
          <div className="title_div">
            <p className="title_text">Nutricos is not a premium experiment.</p>
            <p className="sub_text">It’s a mass movement.</p>
          </div> */}

          <div className="row">
            {whyNutricosData.map((item, index) => (
              <div className="col-sm-6 mb-4" key={index}>
                <div
                  className="imgsec"
                  style={{
                    backgroundImage: `url(${process.env.PUBLIC_URL +
                      item.image})`,
                  }}
                >
                  <img
                    className="prodimg"
                    src={process.env.PUBLIC_URL + item.image}
                    alt={item.title}
                  />

                  <div className="content">
                    <h6>{item.title}</h6>
                    <p>{item.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Why_nutricos;
